<template>
<v-layout>
  <v-flex xs12>
  <v-card>
    <v-card-title>
      <v-btn color="info" href="#/operator/add" @click="goToAdd()">Add Operator</v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="operatorList"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.operatorId }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.countryName }}</td>
        <td class="text-xs-left">{{ props.item.countryCode }}</td>
        <td class="text-xs-left">{{ props.item.countryISO }}</td>
        <td class="text-xs-center">{{ props.item.status ? 'Active' : 'Inactive'}}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteOperator(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Sorry!!! No result found for your search "{{ search }}".
      </v-alert>
    </v-data-table>
  </v-card>
  </v-flex>

  <v-flex v-if="deleteDialog">
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="title">Do you want to change the status of the operator?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" outline @click.native="deleteDialog = false; selectedOperator = null">Cancel</v-btn>
          <v-btn color="primary" outline @click.native="deleteConfirmed()">Change</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>


  </v-layout>
</template>
<script>
import axios from "axios";
import { SERVER_URL } from "./../../constant.js";
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Operator Id",
          value: "operatorId",
          align: "left"
        },
        {
          text: "Name",
          value: "name",
          align: "left"
        },
        {
          text: "Country Name",
          align: "left",
          value: "countryName",
          sortable: false
        },
        {
          text: "Country Code",
          align: "left",
          value: "countryCode",
          sortable: false
        },
        {
          text: "Country ISO",
          align: "left",
          value: "countryISO",
          sortable: false
        },

        {
          text: "Status",
          value: "status",
          align: "center",
          sortable: false
        }
      ],
      countries: [],
      operatorList: [],

      deleteDialog: false,
      selectedOperator: null

    };
  },
  created() {
    axios.get(`${SERVER_URL}/operator/all`).then(res => {
      this.operatorList = res.data;
    });
  },
  methods: {
    goToAdd() {
      this.$router.push("/operator/add");
    },
    deleteOperator ( operator ) {
      this.selectedOperator = operator;
      this.deleteDialog = true;
    },
    deleteConfirmed() {
      
      let operator = this.selectedOperator;

      operator.status = ! operator.status;

      this.deleteDialog = false;

      axios
      .post(`${SERVER_URL}/operator/update`, operator)
      .then(res => {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Operator Url Deleted Successfully"
        });

        document.dispatchEvent(showSnackbarEvent);
        var changedIndex = this.operatorList.findIndex(
          optor =>
            optor.operatorId === operator.operatorId
        );
        this.$set(this.operatorList, changedIndex, operator);
        this.selectedNetwork = null;

      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/operator/ListOperator.vue